import React from 'react'
import s from './index.module.css'
import Slider from 'react-slick'
import { PaperClose } from '../../svg/paper_close'
import { PaperTwoLines } from '../../svg/paper_two_lines'
import { UserPlus } from '../../svg/user_plus'

const settings = {
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 20000,
  initialSlide: 0,
  centerPadding: '0px',
  appendDots: dots => <ul style={{ bottom: '-35px' }}>{dots}</ul>,
  customPaging: i => <span className="ft-slick__dots--custom"></span>,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        dots: true,
        centerMode: false,
        infinite: false,
        variableWidth: true,
        centerPadding: '-60px',
        className: 'slick-partial-imagen',
      },
    },
  ],
}
const cardData = [
  {
    image: (
      <PaperTwoLines fill={'#00CCCC'} className={`${s.itemBoxIco} tw-mb-4`} />
    ),
    title:
      'Trabajadores con relación laboral e incluidos en la lista publicada en el diario Oficial "El Peruano".',
    text:
      'Plazo para afiliarse: 10 días hábiles a partir del día siguiente de la publicación en la lista del padrón en el diario Oficial "ElPeruano".',
  },
  {
    image: (
      <PaperClose fill={'#00CCCC'} className={`${s.itemBoxIco} tw-mb-4`} />
    ),
    title:
      'Para los trabajadores que a la fecha de publicación de la lista no cuenten con relación laboral.',
    text:
      'Plazo para afiliarse: 10 días hábiles a partir de la fecha de inicio de su relación laboral.',
  },
  {
    image: <UserPlus fill={'#00CCCC'} className={`${s.itemBoxIco} tw-mb-4`} />,
    title: 'Para el caso de los nuevos trabajadores pesqueros.',
    text:
      'Plazo para afiliarse: 10 días hábiles a partir de la fecha de inicio de su relación laboral.',
  },
]

const CardSlider = () => (
  <div className={`tw-px-20@lg tw-mx-5@lg`}>
    <Slider {...settings}>
      {cardData.map(item => (
        <div className={`tw-p-3 tw-px-5@lg`} key={item.title}>
          <div
            className={`${s.itemBox} border-0 shadow-3 brad-4 tw-p-8 tw-pt-6 bg-white`}
          >
            {item.image}
            <h3
              className={`font-family-secondary c-gray--4 fw-7 tw-f-20 tw-mt-0 tw-mb-4 tw-mb-4@lg`}
            >
              {item.title}
            </h3>
            <div className={`font-family-primary c-gray--4 tw-4 tw-f-16`}>
              {item.text}
            </div>
          </div>
        </div>
      ))}
    </Slider>
  </div>
)

export default CardSlider
